export default __webpack_public_path__ + "static/media/FLORIDA.56bab3d7.svg";